<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row class="mx-md-n3 mx-1">
        <div class="col-sm col-12 mb-sm-0 mb-3">
          <b-input-group>
            <b-form-input
              v-model="filter"
              @keyup.enter="findAll"
              placeholder="Procurar por..."
            />
            <b-input-group-append>
              <b-button size="md" text="Button" variant="outline-info" @click.passive="findAll">
                <i class="cui-magnifying-glass"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-sm-auto col-12">
          <button type="button" class="btn btn-success mobile-btn-100" @click="openNewLocationGroupFormModal">Novo Grupo</button>
        </div>
      </b-row>
    </b-card>

    <div v-if="loadingRows" class="row mx-0">
      <div  class="col-12 mb-5 pb-5">
        <loading-animation />
      </div>
    </div>

    <div v-if="!loadingRows && (!groups || !groups.length)" class="row mx-0">
      <div v-if="!loadingRows && (!groups || !groups.length)" class="col-12 text-center bg-light py-3">
        Nenhum Grupo encontrado
      </div>
    </div>

    <div v-if="!loadingRows && groups && groups.length" class="row mx-0 border">
      <div v-for="(group, index) in groups" class="col-auto border cursor-pointer m-2" :key="index" @click="editItem(index)">
        <h2 class="my-1">{{group.name}}</h2>
      </div>
    </div>

    <nav class="mt-3">
      <b-pagination
        v-if="totalRows"
        align="center"
        :limit="10"
        :total-rows="totalRows"
        :per-page="perPage"
        prev-text="Anterior"
        next-text="Próximo"
        v-model="currentPage"
        @change="pageChanged"
        :disabled="loadingRows"/>
    </nav>

    <b-modal
      centered
      size="sm"
      lazy
      :title="currentLocationGroup && currentLocationGroup.id ? 'Editar Grupo' : 'Novo Grupo'"
      header-bg-variant="info"
      footer-border-variant="info"
      v-model="showLocationGroupFormModal">
      <b-container v-if="currentLocationGroup">
        <div v-if="loadingCurrentGroup || saving">
          <loading-animation />
        </div>

        <div v-else>
          <b-form-group
            id="name"
            label="Nome"
            label-for="name"
          >
            <b-form-input
              required
              id="name"
              type="text"
              v-model="currentLocationGroup.name"/>
          </b-form-group>
        </div>
      </b-container>

      <template v-if="currentLocationGroup" slot="modal-footer">
        <div class="row justify-content-between w-100 mx-0">
          <div class="col-auto">
            <b-button v-if="currentLocationGroup.id" variant="danger" @click="openDeleteModal"
              :disabled="loadingCurrentGroup || saving">
              Excluír
            </b-button>
          </div>
          <div class="col-auto">
            <b-button variant="primary" @click="saveLocationGroup"
              :disabled="loadingCurrentGroup || saving || !currentLocationGroup.name || !currentLocationGroup.name.length">
              Salvar
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <confirmation-modal
      id="delete-confirmation-modal"
      msg="Tem certeza de que deseja excluír esse grupo?"
      :ok="deleteItem"
    ></confirmation-modal>
  </div>
</template>

<script>
  import { LoadingAnimation } from '@/components/loaders'
  import { httpClient } from '@/service'
  import shared from '@/shared/shared'
  import ConfirmationModal from '@/components/common/confirmation-modal'

  export default {
    name: 'groups',
    components: { LoadingAnimation, ConfirmationModal },

    data: () => {
      return {
        currentPage: 1,
        perPage: 50,
        totalRows: null,
        groups: [],
        grouper: null,
        loadingRows: false,
        filter: '',
        showLocationGroupFormModal: false,
        saving: false,
        currentLocationGroup: {},
        editIndex: null,
        deleteIndex: null,
        loadingCurrentGroup: false
      }
    },

    mounted() {
      this.grouper = shared.getLocalStorageObj('warehouse/grouper');
      this.$store.commit('app/SET_CURRENT_PAGE', { title:`Grupos do agrupador ${this.grouper.name}`, size: 6 });
      this.findAll();
    },

    methods: {
      findAll() {
        let conditions = [{
          field: 'locationGrouper.id',
          value: this.grouper.id
        }];

        if (this.filter && this.filter.length) {
          conditions.push({
            field: 'name',
            conditionalOperator: 'LIKE_START',
            value: this.filter
          });
        }

        this.loadingRows = true;
        httpClient.post(
          `${process.env.VUE_APP_API_URL}location-groups/select-and-where?page=${this.currentPage - 1}&size=${this.perPage}`, {
          select: ['id', 'name'],
          where: {
            conditions: conditions,
            orderBies: [{
              direction: 'ASC',
              condition: { field: 'name' }
            }]
          }
        }).then(({ data }) => {
          this.loadingRows = false;
          this.groups = data.data.content;
          this.totalRows = data.data.totalElements
        })
        .catch((error) => {
          this.loadingRows = false;
          if (error.message) {
            this.$notify.error(error)
          }
          this.groups = [];
        });
      },

      pageChanged(page) {
        this.currentPage = page;
        this.findAll();
      },

      openNewLocationGroupFormModal() {
        this.editIndex = null;
        this.currentLocationGroup = {};
        this.showLocationGroupFormModal = true;
      },

      saveLocationGroup() {
        this.saving = true;
        this.currentLocationGroup.locationGrouper = this.grouper;
        let promise;

        if (this.currentLocationGroup.id) {
          promise = httpClient.patch(`${process.env.VUE_APP_API_URL}location-groups/${this.currentLocationGroup.id}`, {
            name: this.currentLocationGroup.name
          });
        } else {
          promise = httpClient.post(`${process.env.VUE_APP_API_URL}location-groups`, this.currentLocationGroup);
        }

        promise.then(({ data }) => {
          this.saving = false;
          this.$notify.success('Grupo salvo com sucesso');

          let index = this.groups.length;

          if (this.editIndex != null) {
            index = this.editIndex;
          }

          this.groups[index] = data.data;
          this.editIndex = null;
          this.currentLocationGroup = {};
          this.showLocationGroupFormModal = false;
        })
        .catch((error) => {
          this.saving = false;
          if (error.message) {
            this.$notify.error(error)
          }
        });
      },

      editItem(index) {
        this.showLocationGroupFormModal = true;
        this.loadingCurrentGroup = true;
        httpClient.get(`${process.env.VUE_APP_API_URL}location-groups/${this.groups[index].id}`)
        .then(({ data }) => {
          this.loadingCurrentGroup = false;
          this.editIndex = index;
          this.currentLocationGroup = data.data;
        })
        .catch((error) => {
          this.loadingCurrentGroup = false;
          if (error.message) {
            this.$notify.error(error)
          }
        });
      },

      openDeleteModal() {
        this.deleteIndex = this.editIndex;
        this.$bvModal.show('delete-confirmation-modal');
      },

      deleteItem() {
        this.saving = true;
        httpClient.delete(`${process.env.VUE_APP_API_URL}location-groups`, this.groups[this.deleteIndex].id)
        .then(({ data }) => {
          this.saving = false;
          this.$notify.success('Grupo excluído com sucesso');
          this.groups.splice(this.deleteIndex, 1);
          this.deleteIndex = null;
          this.showLocationGroupFormModal = false;
        })
        .catch((error) => {
          this.saving = false;
          if (error.message) {
            this.$notify.error(error)
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
